import { fuzzyDateParse } from "../../util.js";
import { iso3to2 } from "../countryCodes.js";
import { createMappingWarning, mapGender, mapIso3166 } from "../utils.js";
export function mapPassportToCustomer(passport) {
    const errors = [];
    const warnings = [];
    const personDetails = {
        firstName: passport.firstName,
        lastName: passport.lastName,
        birthDate: fuzzyDateParse(passport.dateOfBirth, {
            twoDigitYearCentury: "past",
        }).toISODate() ?? undefined,
        gender: mapGender(passport.gender),
    };
    const isoAlpha2 = iso3to2[passport.issuingCountry?.trim().toUpperCase()];
    const identification = {
        type: "PP Paspoort",
        idNumber: passport.documentNumber,
        issueCountry: isoAlpha2 ? mapIso3166(isoAlpha2) : undefined,
    };
    if (!personDetails.gender) {
        warnings.push(createMappingWarning("passport.gender", `Could not map gender value: ${passport.gender}`, passport.gender));
    }
    const customer = {
        personDetails,
        identification,
        contactDetails: {},
        otherDetails: {},
        residence: {},
    };
    return { customer, errors, warnings };
}
export function mapIdCardToCustomer(idCard) {
    const errors = [];
    const warnings = [];
    const personDetails = {
        firstName: idCard.firstName,
        lastName: idCard.lastName,
        birthDate: fuzzyDateParse(idCard.dateOfBirth, {
            twoDigitYearCentury: "past",
        }).toISODate() ?? undefined,
        gender: mapGender(idCard.gender),
    };
    const isoAlpha2 = iso3to2[idCard.issuingCountry.trim().toUpperCase()];
    const identification = {
        type: "EI Europese identiteitskaart",
        idNumber: idCard.documentNumber,
        issueCountry: isoAlpha2 ? mapIso3166(isoAlpha2) : undefined,
    };
    if (!personDetails.gender) {
        warnings.push(createMappingWarning("id-card.gender", `Could not map gender value: ${idCard.gender}`, idCard.gender));
    }
    const customer = {
        personDetails,
        identification,
        contactDetails: {},
        otherDetails: {},
        residence: {},
    };
    return { customer, errors, warnings };
}
